'use strict';

document.addEventListener('DOMContentLoaded', () => {
  // popup cookie
  const popupCookie = document.querySelector('.cookie');
  const popupCookieButton = document.querySelector('.cookie__button');
  const cookieView = localStorage.getItem('cookie');

  if(!cookieView) {
    popupCookie.classList.add('popup--open');
  }

  popupCookieButton.addEventListener('click', () => {
    localStorage.setItem('cookie', true);
    popupCookie.classList.remove('popup--open');
  });
});